/**
 * React Query: ключи и базовые запросы.
 *
 * Ключи держим в одном месте, чтобы инвалидация после мутации не превращалась
 * в поиск по строкам. Polling 12 секунд — только на активных экранах (раздел 1).
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

import { ApiError, api } from '@/shared/api/client'
import type { Me } from '@/shared/api/types'

export const POLL_INTERVAL_MS = 12_000

export const queryKeys = {
  me: ['me'] as const,
  day: (familyId: number, date: string) => ['day', familyId, date] as const,
  shift: (familyId: number, shiftId: number) => ['shift', familyId, shiftId] as const,
  tasks: (familyId: number, from: string, to: string) => ['tasks', familyId, from, to] as const,
  expenses: (familyId: number) => ['expenses', familyId] as const,
  timesheet: (familyId: number, id: number | string) => ['timesheet', familyId, id] as const,
  trust: (familyId: number) => ['trust', familyId] as const,
}

export function useMe(options?: Partial<UseQueryOptions<Me, ApiError>>) {
  return useQuery<Me, ApiError>({
    queryKey: queryKeys.me,
    queryFn: () => api.get<Me>('/me'),
    // профиль меняется редко, но кэш не должен переживать переоткрытие аппа
    staleTime: 60_000,
    retry: (failureCount, error) => !error.isAuth && failureCount < 2,
    ...options,
  })
}
